export default __webpack_public_path__ + "static/media/image3.96cd0c1b.jpg";